import clsx from "clsx";

import { GenericTooltip } from "@components/tooltip-container";
import { metrics } from "@north-beam/nb-common";
import { Button } from "@shared/buttons/button";

interface Props {
  isDisabled?: boolean;
  dataType?: metrics.MetricType;
  setDataType: (dataType: metrics.MetricType) => void;
}

const DATATYPE_ICONS: {
  icon: string;
  value: metrics.MetricType;
  display: string;
}[] = [
  {
    icon: "00",
    value: metrics.MetricTypes.INTEGER,
    display: "Whole Number",
  },
  {
    icon: "00",
    value: metrics.MetricTypes.DECIMAL,
    display: "Decimal",
  },
  {
    icon: "percent",
    value: metrics.MetricTypes.PERCENTAGE,
    display: "Percentage",
  },
  {
    icon: "dollar-sign",
    value: metrics.MetricTypes.CURRENCY,
    display: "Currency",
  },
  {
    icon: "xmark",
    value: metrics.MetricTypes.MULTIPLIER,
    display: "Multiplier",
  },
];

export const DataTypeSelect = ({
  dataType,
  setDataType,
  isDisabled,
}: Props) => {
  return (
    <div>
      <div
        className={clsx("text-xs font-medium tracking-wider pb-1 pt-0.5", {
          "text-disabled": isDisabled,
        })}
      >
        DATA TYPE
      </div>
      <div className="flex items-center">
        {DATATYPE_ICONS.map(({ icon, value, display }, index) => (
          <GenericTooltip
            key={value}
            content={display}
            noInfoCircle
            mouseEnterDelay={0.25}
          >
            <Button
              className={clsx("p-0 h-8 w-8 border border-gray-1", {
                "rounded-s-md rounded-e-none border-r-0": index === 0,
                "rounded-none border-r-0":
                  index !== 0 && index !== DATATYPE_ICONS.length - 1,
                "rounded-e-md rounded-s-none":
                  index === DATATYPE_ICONS.length - 1,
                "border-none": dataType === value,
              })}
              variant={dataType === value ? "primary" : "secondary"}
              disabled={isDisabled}
              loading={false}
              onClick={() => setDataType(value)}
            >
              {value === metrics.MetricTypes.DECIMAL ? (
                <span className="leading-0 font-normal text-xxs">0.00</span>
              ) : (
                <i
                  className={clsx("fa-regular", `fa-${icon}`, {
                    "text-interstellar": dataType !== value,
                  })}
                />
              )}
            </Button>
          </GenericTooltip>
        ))}
      </div>
    </div>
  );
};
